import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import Modal from 'app/src/elements/Modal';
import { Title } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

import { Button } from './elements';
import { CHOOSE_BID_GROUP } from './queries';
import SaleAssetDetail from './SaleAssetDetail';

const Container = styled(View)`
  margin-bottom: 10px;
  gap: 10px;
`;

const Choices = styled(View)`
  flex-direction: row;
  gap: 10px;
`;

const Choice = styled(View)`
  flex: 1;
`;

const BidGroupChoose = ({ sale, saleAssets }) => {
  const id = sale.bidGroupChoiceId;
  const [selectedIds, setSelectedIds] = useState([]);
  const [showDetail, setShowDetail] = useState(false);

  const [chooseBidGroup] = useMutation(CHOOSE_BID_GROUP);

  const toggleSelectedId = id => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const options = saleAssets.
    filter(saleAsset => id === saleAsset.pendingBidGroupId);

  const isSelected = saleAsset => selectedIds.includes(saleAsset.id);

  const handleSubmit = () => {
    chooseBidGroup({ variables: { id, saleAssetIds: selectedIds } });
  };

  return (
    <Container>
      {sale.bidGroupBuyerId && (
        <Title style={{color: colors.elRed}}>
          Choice Block is also being displayed to Buyer
        </Title>
      )}
      <Choices>
        {options.map(saleAsset => (
          <Choice key={saleAsset.id}>
            <View style={{ flexDirection: 'row', gap: 10 }}>
              <Title>{saleAsset.correctedLotNumber}</Title>
              <Pressable onPress={() => setShowDetail(saleAsset)}>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </Pressable>
            </View>
            <Button
              title={isSelected(saleAsset) ? 'Selected ✓' : 'Select'}
              color={isSelected(saleAsset) ? colors.elGreen : 'darkgray'}
              onPress={() => toggleSelectedId(saleAsset.id)}
              style={{ minHeight: 30 }}
            />
          </Choice>
        ))}
      </Choices>

      <Button
        title="Submit Selections"
        disabled={0 === selectedIds.length}
        style={{ minHeight: 30 }}
        onPress={handleSubmit}
      />
      {showDetail && (
        <Modal
          showModal={showDetail}
          setShowModal={setShowDetail}
          modalType={showDetail.correctedLotNumber}
        >
          <View style={{height: 500, maxWidth: 600}}>
            <SaleAssetDetail saleAsset={showDetail} />
          </View>
        </Modal>
      )}
    </Container>
  );
};

export default BidGroupChoose;
